import { ReactNode } from "react";
import { Badge } from "reactstrap";

export function generateTags(tags: string[]): ReactNode {
  return tags.map((s: string) => (
    <Badge color="dark" className="me-2" key={s}>
      {s}
    </Badge>
  ));
}

export function generateSongNumbers(mnemonicNumber: string[]): ReactNode {
  return mnemonicNumber.map((s: string) => (
    <Badge color="light" className="text-dark me-2" key={s}>
      {s}
    </Badge>
  ));
}
